<div class="spinner-value">{{ progress() }}%</div>
<mat-progress-spinner [color]="color()" [diameter]="diameter()" [mode]="mode()" [strokeWidth]="strokeWidth()" [value]="progress()"> </mat-progress-spinner>
